import { css } from 'styled-components';

export const styles = css`
  background-color: ${p => p.theme.token('background-default')};
  color: ${p => p.theme.token('text-default')};
  border: 1px solid ${p => p.theme.token('border-color-default')};
`;
